<template>
  <div class='EnbProfile'>
    <card-link v-if="Profile.tipo !== 'c'" label="Painel" icon="EngineerIcon" @click="$router.push('/painel')"/>
    <card-link v-if="Profile.tipo === 'c'" icon="PerfilIcon" label="Perfil" @click="$router.push('/perfil')"/>
    <card-link v-if="Profile.tipo === 'c'" icon="ListIcon" label="Pedidos" @click="$router.push('/pedidos')"/>
    <card-link v-if="Profile.tipo === 'c'" icon="HeartIcon" label="Favoritos" @click="$router.push('/likes')"/>
    <card-link label="Sair" icon="LogoutIcon" @click="logout"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardLink from './CardLink'
export default {
  name: 'EnbProfile',
  components: { CardLink },
  computed: {
    ...mapGetters(['Profile'])
  },
  methods: {
    ...mapActions(['GetLogout']),
    logout () {
      this.GetLogout()
        .then(() => this.$router.push('/loja'))
    }
  }
}
</script>

<style scoped>
.EnbProfile {
  width: 80%;
  min-height: 400px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 500px) {
  .EnbProfile {
    align-items: start;
    padding-top: 17%;
  }
}
</style>
